import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { dashboardActions } from '$store/dashboard/index';
import { Api } from '$api';
import { batchActions } from '$store';
import { toastActions } from '$store/toast';
import { balanceActions } from '$store/balance';
import { loadInvitesFriendsWorker } from '$store/invite/sagas';
import { CompleteTaskAction } from '$store/dashboard/interface';
import { statReachGoal } from '$utils';

function* loadDashboardWorker() {
  try {
    yield fork(loadInvitesFriendsWorker);
    const data = yield call(Api.post, '/dashboard');
    yield put(
      batchActions(
        dashboardActions.loadDashboardSuccess(data),
        balanceActions.setEurBalance(data.eurBalance),
        balanceActions.setHoldBalance(data.eurHoldBalance),
        balanceActions.setTonHoldBalance(data.tonHoldBalance),
        dashboardActions.setSquadId(data.squadId),
      ),
    );
  } catch (e) {
    yield put(
      batchActions(
        dashboardActions.loadDashboardFailure(),
        toastActions.setToastFail(e.message),
      ),
    );
  }
}

function* completeTaskWorker(action: CompleteTaskAction) {
  const task = action.payload;
  try {
    yield put(
      dashboardActions.setCompleteTask({
        taskId: task.id,
        value: true,
      }),
    );
    yield call(Api.post, `/dashboard/task/${task.id}/complete`);

    if (task.action) {
      yield call(statReachGoal, 'task_complete', {
        taskId: task.id,
        actionType: task.action.type,
      });
    }

    yield loadDashboardWorker();
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
    yield put(
      dashboardActions.setCompleteTask({
        taskId: task.id,
        value: false,
      }),
    );
  }
}

export function* dashboardSaga() {
  yield all([
    takeLatest(dashboardActions.loadDashboard, loadDashboardWorker),
    takeLatest(dashboardActions.completeTask, completeTaskWorker),
  ]);
}
